export default "/images/vendor/chocolat/dist/close.png?f34f1833ade0883331c4c259583fef4d";